import { WeatherState } from "@/store/type";

const STORAGE_KEY = "weather-store";

export const loadWeatherState = () => {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
};

export const saveWeatherState = (state: Partial<WeatherState>) => {
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
	} catch {}
};

export const reviveDates = (state: WeatherState): Partial<WeatherState> => {
	if (!state) {
		return state;
	}

	return {
		...state,
		forecastCity: state.forecastCity
			? {
					...state.forecastCity,
					selectedDate: new Date(state.forecastCity.selectedDate),
			  }
			: undefined,
		previsionMarine: state.previsionMarine ? { date: new Date() } : undefined,
	};
};
